module.exports = {
	"v": "4.8.0",
	"meta": {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	"fr": 30,
	"ip": 0,
	"op": 155,
	"w": 500,
	"h": 180,
	"nm": "10MM_CardSpot_NoLoop_02_Lottie",
	"ddd": 0,
	"assets": [],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 3,
			"nm": "Null 3",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 0,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": 0.4,
								"y": 1
							},
							"o": {
								"x": 0.333,
								"y": 0
							},
							"t": 10,
							"s": [
								87,
								90,
								0
							],
							"to": [
								0,
								0,
								0
							],
							"ti": [
								0,
								0,
								0
							]
						},
						{
							"t": 70,
							"s": [
								409,
								90,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Dollar Sign/10MM_Card_01 Outlines",
			"parent": 3,
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.4
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 22.885,
							"s": [
								0
							]
						},
						{
							"t": 74.4228515625,
							"s": [
								100
							]
						}
					],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0.5,
						-1.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						114,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											-1.847,
											-1.921
										],
										[
											0,
											-3.109
										],
										[
											0,
											0
										],
										[
											1.995,
											-1.702
										],
										[
											3.842,
											-0.257
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											2.89,
											0.694
										],
										[
											0,
											0
										],
										[
											-4.976,
											0
										],
										[
											-1.135,
											0.606
										],
										[
											0,
											1.537
										],
										[
											0,
											0
										],
										[
											0.713,
											0.641
										],
										[
											1.318,
											0
										],
										[
											0,
											0
										],
										[
											1.995,
											1.758
										],
										[
											0,
											3.989
										],
										[
											0,
											0
										],
										[
											-1.885,
											1.847
										],
										[
											-3.697,
											0.292
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-3.478,
											-0.733
										],
										[
											0,
											0
										],
										[
											2.562,
											0
										],
										[
											1.061,
											-0.638
										],
										[
											0,
											-1.72
										],
										[
											0,
											0
										],
										[
											-0.787,
											-0.641
										],
										[
											-1.611,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											1.847,
											1.921
										],
										[
											0,
											0
										],
										[
											0,
											4.063
										],
										[
											-1.995,
											1.702
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											-4.099,
											-0.184
										],
										[
											0,
											0
										],
										[
											3.257,
											0.328
										],
										[
											2.232,
											0
										],
										[
											1.135,
											-0.603
										],
										[
											0,
											0
										],
										[
											0,
											-1.208
										],
										[
											-0.715,
											-0.639
										],
										[
											0,
											0
										],
										[
											-4.027,
											0
										],
										[
											-1.995,
											-1.756
										],
										[
											0,
											0
										],
										[
											0,
											-3.585
										],
										[
											1.885,
											-1.85
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											3.186,
											0.147
										],
										[
											0,
											0
										],
										[
											-5.015,
											-0.329
										],
										[
											-2.086,
											0
										],
										[
											-1.061,
											0.642
										],
										[
											0,
											0
										],
										[
											0,
											1.392
										],
										[
											0.786,
											0.639
										],
										[
											0,
											0
										],
										[
											3.514,
											0
										]
									],
									"v": [
										[
											10.898,
											-0.988
										],
										[
											13.669,
											6.561
										],
										[
											13.669,
											8.866
										],
										[
											10.678,
											17.512
										],
										[
											1.923,
											20.451
										],
										[
											1.923,
											25.061
										],
										[
											-2.689,
											25.061
										],
										[
											-2.689,
											20.451
										],
										[
											-13.173,
											19.133
										],
										[
											-13.173,
											12.711
										],
										[
											-0.824,
											13.204
										],
										[
											4.227,
											12.297
										],
										[
											5.93,
											9.087
										],
										[
											5.93,
											7.604
										],
										[
											4.859,
											4.831
										],
										[
											1.812,
											3.87
										],
										[
											-1.646,
											3.87
										],
										[
											-10.676,
											1.236
										],
										[
											-13.669,
											-7.382
										],
										[
											-13.669,
											-9.359
										],
										[
											-10.842,
											-17.51
										],
										[
											-2.469,
											-20.723
										],
										[
											-2.689,
											-23.742
										],
										[
											1.648,
											-25.061
										],
										[
											1.923,
											-20.779
										],
										[
											1.757,
											-20.723
										],
										[
											11.749,
											-19.404
										],
										[
											11.749,
											-12.982
										],
										[
											0.385,
											-13.477
										],
										[
											-4.337,
											-12.516
										],
										[
											-5.928,
											-8.975
										],
										[
											-5.928,
											-7.876
										],
										[
											-4.747,
											-4.829
										],
										[
											-1.152,
											-3.87
										],
										[
											2.855,
											-3.87
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 4
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 5
							},
							"r": 1,
							"bm": 0,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									200.085,
									114.824
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Group 1",
					"np": 2,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Circle 4",
			"parent": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.2
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 10,
							"s": [
								-360
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 66.692,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.4
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 85,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 115,
							"s": [
								360
							]
						},
						{
							"t": 175,
							"s": [
								360
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						36.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 3,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							70,
							70
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 100,
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 39,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.2
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 21.596,
								"s": [
									100
								]
							},
							{
								"t": 75.7119140625,
								"s": [
									0
								]
							}
						],
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 100,
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 3,
					"nm": "Trim Paths 2",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.188235297799,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Circle 3",
			"parent": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									0.2
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0.167
								]
							},
							"t": 10,
							"s": [
								-360
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 77,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0
								]
							},
							"t": 85,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.2
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.333
								],
								"y": [
									0
								]
							},
							"t": 92.5,
							"s": [
								0
							]
						},
						{
							"i": {
								"x": [
									0.833
								],
								"y": [
									1
								]
							},
							"o": {
								"x": [
									0.167
								],
								"y": [
									0
								]
							},
							"t": 130,
							"s": [
								360
							]
						},
						{
							"t": 175,
							"s": [
								360
							]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						36.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 3,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							86,
							86
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 0,
						"k": 10,
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": -69,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.4
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.333
									],
									"y": [
										0
									]
								},
								"t": 20.308,
								"s": [
									0
								]
							},
							{
								"t": 61.5380859375,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 3,
					"nm": "Trim Paths 2",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				},
				{
					"ty": "st",
					"c": {
						"a": 0,
						"k": [
							0,
							0.188235297799,
							0.341176480055,
							1
						],
						"ix": 3
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 4
					},
					"w": {
						"a": 0,
						"k": 3,
						"ix": 5
					},
					"lc": 2,
					"lj": 2,
					"bm": 0,
					"nm": "Stroke 1",
					"mn": "ADBE Vector Graphic - Stroke",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Card Matte",
			"parent": 1,
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						36.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.131
										],
										[
											0,
											0
										],
										[
											-5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-5.131
										],
										[
											0,
											0
										],
										[
											5.131,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-5.131
										],
										[
											0,
											0
										],
										[
											5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.131
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-166.502,
											-66.206
										],
										[
											-259.093,
											-66.353
										],
										[
											-268.384,
											-75.644
										],
										[
											-268.384,
											-157.356
										],
										[
											-259.093,
											-166.647
										],
										[
											-140.906,
											-166.647
										],
										[
											-131.616,
											-157.356
										],
										[
											-131.616,
											-75.644
										],
										[
											-140.906,
											-66.353
										],
										[
											-165.951,
											-66.353
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 40,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									199.949,
									59.983
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Outer Box",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							70,
							70
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Lines 2",
			"parent": 1,
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						-19,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						61,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											38.492,
											8.044
										],
										[
											-38.492,
											8.044
										],
										[
											-38.492,
											-8.044
										],
										[
											38.492,
											-8.044
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": -160,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 85,
										"s": [
											77.758,
											31.023
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.6,
											"y": 0
										},
										"t": 89,
										"s": [
											77.758,
											31.023
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.6,
											"y": 0.6
										},
										"t": 134,
										"s": [
											199.758,
											31.023
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 175,
										"s": [
											199.758,
											31.023
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rect",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											176.104,
											50.473
										],
										[
											224.346,
											50.473
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 0.4
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 85,
										"s": [
											-122,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.6,
											"y": 0
										},
										"t": 93,
										"s": [
											-122,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.6,
											"y": 0.6
										},
										"t": 138,
										"s": [
											0,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 175,
										"s": [
											0,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											152.676,
											63.187
										],
										[
											246.89,
											63.187
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 0.4
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 85,
										"s": [
											-122,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.6,
											"y": 0
										},
										"t": 97,
										"s": [
											-122,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.6,
											"y": 0.6
										},
										"t": 142,
										"s": [
											0,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 175,
										"s": [
											0,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 2",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Card Matte 2",
			"parent": 1,
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						36.5,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.131
										],
										[
											0,
											0
										],
										[
											-5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-5.131
										],
										[
											0,
											0
										],
										[
											5.131,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-5.131
										],
										[
											0,
											0
										],
										[
											5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.131
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											-166.502,
											-66.206
										],
										[
											-259.093,
											-66.353
										],
										[
											-268.384,
											-75.644
										],
										[
											-268.384,
											-157.356
										],
										[
											-259.093,
											-166.647
										],
										[
											-140.906,
											-166.647
										],
										[
											-131.616,
											-157.356
										],
										[
											-131.616,
											-75.644
										],
										[
											-140.906,
											-66.353
										],
										[
											-165.951,
											-66.353
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 40,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									199.949,
									59.983
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Outer Box",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							70,
							70
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Lines",
			"parent": 1,
			"tt": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						-19,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						61,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											38.492,
											8.044
										],
										[
											-38.492,
											8.044
										],
										[
											-38.492,
											-8.044
										],
										[
											38.492,
											-8.044
										]
									],
									"c": true
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": -160,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.6,
											"y": 0
										},
										"t": 85,
										"s": [
											199.758,
											31.023
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 130,
										"s": [
											320.758,
											31.023
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 175,
										"s": [
											320.758,
											31.023
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Rect",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											176.104,
											50.473
										],
										[
											224.346,
											50.473
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 85,
										"s": [
											0,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.6,
											"y": 0
										},
										"t": 89,
										"s": [
											0,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 134,
										"s": [
											121,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 175,
										"s": [
											121,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 1",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 2,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											152.676,
											63.187
										],
										[
											246.89,
											63.187
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 0,
								"ix": 3
							},
							"m": 1,
							"ix": 3,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 85,
										"s": [
											0,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.4,
											"y": 1
										},
										"o": {
											"x": 0.6,
											"y": 0
										},
										"t": 93,
										"s": [
											0,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"t": 138,
										"s": [
											121,
											0
										],
										"to": [
											0,
											0
										],
										"ti": [
											0,
											0
										]
									},
									{
										"t": 175,
										"s": [
											121,
											0
										]
									}
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Line 2",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 3,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.4
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 10,
								"s": [
									0
								]
							},
							{
								"t": 65,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 2,
					"ix": 4,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 4,
			"nm": "Circle Fill 2",
			"parent": 3,
			"td": 1,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"d": 1,
					"ty": "el",
					"s": {
						"a": 0,
						"k": [
							70,
							70
						],
						"ix": 2
					},
					"p": {
						"a": 0,
						"k": [
							0,
							0
						],
						"ix": 3
					},
					"nm": "Ellipse Path 1",
					"mn": "ADBE Vector Shape - Ellipse",
					"hd": false
				},
				{
					"ty": "fl",
					"c": {
						"a": 0,
						"k": [
							1,
							0,
							0,
							1
						],
						"ix": 4
					},
					"o": {
						"a": 0,
						"k": 100,
						"ix": 5
					},
					"r": 1,
					"bm": 0,
					"nm": "Fill 1",
					"mn": "ADBE Vector Graphic - Fill",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 10,
			"ty": 4,
			"nm": "Out Card Rect",
			"parent": 1,
			"tt": 2,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						0,
						-19,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						200,
						61,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [
				{
					"ty": "gr",
					"it": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 0,
								"k": {
									"i": [
										[
											0,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.131
										],
										[
											0,
											0
										],
										[
											-5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-5.131
										],
										[
											0,
											0
										],
										[
											5.131,
											0
										],
										[
											0,
											0
										]
									],
									"o": [
										[
											0,
											0
										],
										[
											-5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											-5.131
										],
										[
											0,
											0
										],
										[
											5.131,
											0
										],
										[
											0,
											0
										],
										[
											0,
											5.131
										],
										[
											0,
											0
										],
										[
											0,
											0
										]
									],
									"v": [
										[
											33.498,
											50.294
										],
										[
											-59.093,
											50.147
										],
										[
											-68.384,
											40.856
										],
										[
											-68.384,
											-40.856
										],
										[
											-59.093,
											-50.147
										],
										[
											59.094,
											-50.147
										],
										[
											68.384,
											-40.856
										],
										[
											68.384,
											40.856
										],
										[
											59.094,
											50.147
										],
										[
											34.049,
											50.147
										]
									],
									"c": false
								},
								"ix": 2
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group",
							"hd": false
						},
						{
							"ty": "tm",
							"s": {
								"a": 0,
								"k": 0,
								"ix": 1
							},
							"e": {
								"a": 0,
								"k": 100,
								"ix": 2
							},
							"o": {
								"a": 0,
								"k": 40,
								"ix": 3
							},
							"m": 1,
							"ix": 2,
							"nm": "Trim Paths 1",
							"mn": "ADBE Vector Filter - Trim",
							"hd": false
						},
						{
							"ty": "st",
							"c": {
								"a": 0,
								"k": [
									0,
									0.188235309077,
									0.341176470588,
									1
								],
								"ix": 3
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 4
							},
							"w": {
								"a": 0,
								"k": 3,
								"ix": 5
							},
							"lc": 2,
							"lj": 2,
							"bm": 0,
							"nm": "Stroke 1",
							"mn": "ADBE Vector Graphic - Stroke",
							"hd": false
						},
						{
							"ty": "tr",
							"p": {
								"a": 0,
								"k": [
									199.949,
									59.983
								],
								"ix": 2
							},
							"a": {
								"a": 0,
								"k": [
									0,
									0
								],
								"ix": 1
							},
							"s": {
								"a": 0,
								"k": [
									100,
									100
								],
								"ix": 3
							},
							"r": {
								"a": 0,
								"k": 0,
								"ix": 6
							},
							"o": {
								"a": 0,
								"k": 100,
								"ix": 7
							},
							"sk": {
								"a": 0,
								"k": 0,
								"ix": 4
							},
							"sa": {
								"a": 0,
								"k": 0,
								"ix": 5
							},
							"nm": "Transform"
						}
					],
					"nm": "Outer Box",
					"np": 3,
					"cix": 2,
					"bm": 0,
					"ix": 1,
					"mn": "ADBE Vector Group",
					"hd": false
				},
				{
					"ty": "tm",
					"s": {
						"a": 0,
						"k": 0,
						"ix": 1
					},
					"e": {
						"a": 1,
						"k": [
							{
								"i": {
									"x": [
										0.4
									],
									"y": [
										1
									]
								},
								"o": {
									"x": [
										0.167
									],
									"y": [
										0.167
									]
								},
								"t": 10,
								"s": [
									0
								]
							},
							{
								"t": 75,
								"s": [
									100
								]
							}
						],
						"ix": 2
					},
					"o": {
						"a": 0,
						"k": 0,
						"ix": 3
					},
					"m": 1,
					"ix": 2,
					"nm": "Trim Paths 1",
					"mn": "ADBE Vector Filter - Trim",
					"hd": false
				}
			],
			"ip": 0,
			"op": 2700,
			"st": 0,
			"bm": 0
		}
	],
	"markers": []
};


//////////////////
// WEBPACK FOOTER
// ./frontend/pages/LiveMarkets/animations/cardSpot/10MM_CardSpot_NoLoop_02_Lottie.json
// module id = 645
// module chunks = 0